import clsx from 'clsx'
import Image from 'next/image'

import playIcon from 'assets/svg/play.svg'

import { Icon } from '@/shared/ui/icon'

import { isReviewVideo, resolveReviewMediaUrl } from '../../lib/media'

import styles from './ReviewMediaPreview.module.scss'

const REVIEW_MEDIA_PREVIEW_SIZE = 160
const REVIEW_MEDIA_PREVIEW_QUALITY = 90

export const ReviewMediaThumb = ({ src, alt }: { src?: string; alt: string }) =>
	src ? (
		<Image
			src={resolveReviewMediaUrl(src)}
			alt={alt}
			width={REVIEW_MEDIA_PREVIEW_SIZE}
			height={REVIEW_MEDIA_PREVIEW_SIZE}
			quality={REVIEW_MEDIA_PREVIEW_QUALITY}
		/>
	) : (
		<span className={styles.mediaFallback} />
	)

export const ReviewMediaPreview = ({ src, alt, className }: { src: string; alt: string; className?: string }) => {
	const mediaUrl = resolveReviewMediaUrl(src)

	return (
		<span className={clsx(styles.mediaPreview, isReviewVideo(src) && styles.mediaPreviewVideo, className)}>
			{isReviewVideo(src) ? (
				<>
					<video src={mediaUrl} muted playsInline preload="metadata" aria-label={alt}>
						<track kind="captions" />
					</video>
					<Icon className={styles.mediaPlayIcon} icon={playIcon} width={39} height={39} title="" />
				</>
			) : (
				<Image
					src={mediaUrl}
					alt={alt}
					width={REVIEW_MEDIA_PREVIEW_SIZE}
					height={REVIEW_MEDIA_PREVIEW_SIZE}
					quality={REVIEW_MEDIA_PREVIEW_QUALITY}
				/>
			)}
		</span>
	)
}
